export const PRACTICE_NAME = import.meta.env.VITE_PRACTICE_NAME || "Radiant Dental";
export const PRACTICE_LOCATION = import.meta.env.VITE_PRACTICE_LOCATION || "Chevy Chase";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000";

export const IDLE_LOCK_MINUTES = Number(import.meta.env.VITE_IDLE_LOCK_MINUTES || 10);
export const IDLE_WARN_MINUTES = 2;

// Demo mode skips the auth gate and uses in-memory data. Useful for design
// reviews without an API. NEVER set true in production.
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === "true";
